import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AssessmentSessionCreateInput } from '../generated/globalTypes';
import { createAssessmentSessionMutation, createAssessmentSessionMutationVariables } from '../generated/createAssessmentSessionMutation';
import { assessmentSessionFieldsFragment } from '../models/AssessmentSession';

/**
 * Get a callback to create a AssessmentSession in the store.
 */
export function useCreateAssessmentSessionCallback(): [(model: AssessmentSessionCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createAssessmentSessionMutation, createAssessmentSessionMutationVariables>(
        gql`
            mutation createAssessmentSessionMutation ($model: AssessmentSessionCreateInput!) {
                createAssessmentSession(model: $model) {
                    ...assessmentSessionFields
                }
            }

            ${assessmentSessionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: AssessmentSessionCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
